import React from 'react';
import { withBoundingRects } from '@vx/bounds';

import { Tooltip } from './tooltip.styles';

const TooltipWithBoundsBase = ({
  left: initialLeft = 0,
  top: initialTop = 0,
  offsetLeft = 10,
  offsetTop = 10,
  rect,
  parentRect,
  children,
  ...otherProps
}) => {
  let left = initialLeft;
  let top = initialTop;

  if (rect && parentRect) {
    left =
      offsetLeft + rect.right > parentRect.right || offsetLeft + rect.right > window.innerWidth
        ? left - rect.width - offsetLeft
        : left + offsetLeft;

    top =
      offsetTop + rect.bottom > parentRect.bottom || offsetTop + rect.bottom > window.innerHeight
        ? top - rect.height - offsetTop
        : top + offsetTop;
  }

  left = Math.round(left);
  top = Math.round(top);

  return (
    <Tooltip top={top} left={left} {...otherProps}>
      {children}
    </Tooltip>
  );
};

export const TooltipWithBounds = withBoundingRects(TooltipWithBoundsBase);
